import { render } from "./WorkSpace.vue?vue&type=template&id=3ef45560&scoped=true"
import script from "./WorkSpace.vue?vue&type=script&lang=js"
export * from "./WorkSpace.vue?vue&type=script&lang=js"

import "./WorkSpace.vue?vue&type=style&index=0&id=3ef45560&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ef45560"]])

export default __exports__